import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import {
    Row,
    Form,
    Button,
    ButtonContainer,
} from 'yurstrap';

import { getLanguageSelector } from '../../../commons/selectors/LanguageSelector';

import {
    getIsBannerHiddenSelector,
    hideBanner,
    getCookiesGroupsConfigurationSelector,
    setWidgetCookies,
} from '../../reduxModules/ConsentManagementPlatform';

import WidgetCookiesCheckbox from './WidgetCookiesCheckbox';

const propTypes = {
    AppActions: PropTypes.shape({
        hideBanner: PropTypes.func.isRequired,
        setWidgetCookies: PropTypes.func.isRequired,
    }).isRequired,
    sessionLanguage: PropTypes.string.isRequired,
    config: PropTypes.array.isRequired,
    isBannerHidden: PropTypes.bool.isRequired,
};

class WidgetBanner extends Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();
        const { AppActions } = this.props;
        AppActions.setWidgetCookies();
    }

    renderCookiesCheckboxes() {
        const { config } = this.props;
        return _.map(config, (cookiesGroup) => {
            if (cookiesGroup.id !== 'ANALYTICS' && cookiesGroup.id !== 'MARKETING') {
                return null;
            }
            return (
                <WidgetCookiesCheckbox
                    key={cookiesGroup.id}
                    cookieGroupId={cookiesGroup.id}
                />
            );
        });
    }

    renderCookieBannerSentence() {
        const { sessionLanguage } = this.props;
        const cookieBannerSentence = sessionLanguage === 'fr'
            ? 'Ce widget utilise des cookies à des fins de suivi de navigation et de marketing. En poursuivant votre navigation vous acceptez le dépôt de ces cookies.'
            : 'This widget uses cookies for statistical analysis and marketing purposes. By continuing to browse on this website, you agree to those terms.';
        return (
            <div className="u-col--m-auto u-col-12 pl-0 pr-2 u-flex--1">
                {cookieBannerSentence}
            </div>
        );
    }

    render() {
        const {
            isBannerHidden,
        } = this.props;
        if (isBannerHidden) return null;
        return (
            <div className="p-3">
                <div className="c-cookie--widget px-4 py-3 p--s-3">
                    <Row vcenter noCol>
                        {this.renderCookieBannerSentence()}
                        <Form
                            onSubmit={this.onSubmit}
                            className="u-col--m-auto u-col-12 px-0"
                        >
                            <Row noCol vcenter>
                                <Row
                                    noCol
                                    vcenter
                                    className="u-col--m-auto u-col-12 px-0"
                                >
                                    {this.renderCookiesCheckboxes()}
                                </Row>
                                <ButtonContainer className="u-col--m-auto u-col-12 px-0">
                                    <Button
                                        color="premium"
                                        type="submit"
                                        className="c-btn--premium"
                                    >
                                        Ok !
                                    </Button>
                                </ButtonContainer>
                            </Row>
                        </Form>
                    </Row>
                </div>
            </div>
        );
    }

}

WidgetBanner.propTypes = propTypes;

function mapStateToProps(state) {
    return {
        config: getCookiesGroupsConfigurationSelector(state),
        isBannerHidden: getIsBannerHiddenSelector(state),
        sessionLanguage: getLanguageSelector(),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            hideBanner,
            setWidgetCookies,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(WidgetBanner);
